import { styled } from 'styletron-react';

export const NavigationItem = styled('li', {
  textAlign: 'center',
});
